const state = () => ({
  rating: null,
  showFeedback: false,
  text: '',
  formSent: false
});

const getters = {
  rating(state) {
    return state.rating;
  },
  showFeedback(state) {
    return state.showFeedback;
  },
  text(state) {
    return state.text;
  },
  formSent(state) {
    return state.formSent;
  }
};

const mutations = {
  setRating(state, payload) {
    state.rating = payload;
  },
  setShowFeedback(state, payload) {
    state.showFeedback = payload;
  },
  setText(state, payload) {
    state.text = payload;
  },
  setFormSent(state, payload) {
    state.formSent = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  setRating({ commit }, payload) {
    commit('setRating', payload);
  },
  setShowFeedback({ commit }, payload) {
    commit('setShowFeedback', payload);
  },
  setText({ commit }, payload) {
    commit('setText', payload);
  },
  setFormSent({ commit }, payload) {
    commit('setFormSent', payload);
  }
};

export const feedback = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
